import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout/Layout";
import { getFrontmatter, getFields } from "../utils/functions";
import SEO from "../components/SEO";
import BoardsSpecsTable from "../components/BoardsSpecsTable";
import Article from "./../components/layout/Article";

const SingleBoard = ({ data, pageContext: { category } }) => {
  const frontmatter = getFrontmatter(category);
  const fields = getFields(category);

  // const { html, excerpt } = data.markdownRemark;
  const {
    title,
    featured_image: { img },
  } = data.markdownRemark[frontmatter];

  const customText = () => {
    switch (category) {
      case "microcontroller":
        return `${title} microcontroller development board`;
      case "single-board-computer":
        return `${title} single-board computer`;
      default:
        return ``;
    }
  };
  return (
    <Layout sidebar={{ recentPosts: true, search: true }}>
      <SEO
        title={title}
        description={`Here is the full list of specifications of the ${customText()}.`}
      />
      <Article title={title}>
        <Img className="w-full max-h-9" fluid={img.childImageSharp.fluid} />

        {/* <div className="mt-8" dangerouslySetInnerHTML={{ __html: html }} /> */}

        <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
          Specifications
        </h2>

        <BoardsSpecsTable
          boardsData={[data.markdownRemark[frontmatter]]}
          fields={fields}
        />
        {/* <a
          href="https://www.amazon.com"
          className="bg-secondary hover:bg-secondary-light px-2 py-1 rounded text-white hover:text-white mt-4 mb-1 inline-block transition duration-300"
        >
          Buy From Amazon
        </a>
        <div className="text-xs">
          <span className="text-red-700">*</span>Commission Earned
        </div> */}
      </Article>
    </Layout>
  );
};

export const singleBoardPageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      excerpt(pruneLength: 170)
      ...MCUFrontmatter
      ...SBCFrontmatter
      fields {
        slug
      }
    }
  }
`;

export default SingleBoard;
